import FinalAssetListReport from './finalAssetListReport'
export default FinalAssetListReport
